import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// 引入axios方法
import http from './request/index'
Vue.prototype.http = http
Vue.prototype.$http = http
//引入betterweapp的方法
import appMethod from './common/app-common'
Vue.prototype.$betterwe = appMethod
import BuriedPoint from './common/buried-point/index'
// 引入微信api
// import wx from "weixin-js-sdk"
// Vue.prototype.wx = wx
// window["wx"] = wx

// 全局fiter
import * as filters from './filters/index'
//全局自定义指令
import installDirectives from './directives/index'
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key])
})
//引入动画
import 'animate.css'
// 引入字体
import './assets/font/font.css'

// 引入iconfont
import './assets/iconfont/iconfont.css'
// 引入vant
import './common/vant.js'
import 'vant/lib/icon/local.css'
// 引入自定义全局组件
import './components/def-component/index.js'
//引入全局自定义指令
installDirectives(Vue)
// 引入wx sdk
import wx from 'weixin-js-sdk'
window['wx'] = wx
// sentry
/* import * as Sentry from '@sentry/vue'
if (process.env.NODE_ENV !== 'development') {
  Sentry.init({
    Vue,
    dsn: 'https://b2de2b52e08a438b9d764c172ed7bbec@sentry.gymcity.com.cn/12',
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    integrations: [
      new Sentry.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router)
      }),
      new Sentry.Replay()
    ],
    tracesSampleRate: 1.0,
    environment: process.env.NODE_ENV
  })
} */

Vue.config.productionTip = false
//忽略微信标签
Vue.config.ignoredElements = ['wx-open-launch-app']
// 友盟埋点 eventCode 事件ID eventParams 事件参数属性
BuriedPoint.init(Vue)
new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
